
import { useState, useEffect } from 'react';
import { ReactComponent as ZoomIn } from '../../public/images/svg/Zoom In_01.svg';
import { ReactComponent as ZoomOut } from '../../public/images/svg/Zoom Out_02.svg';
import { GlyphButton } from '../Controls/Button/GlyphButton';
import './css/ClipZoom.css';

export interface ClipZoomResult {
    newValue: number;
}

interface ClipZoomProps {
    zoomValue: number;
    zoomMax?: number;
    canZoomIn?: boolean;
    canZoomOut?: boolean;
    onChange?: (result: ClipZoomResult) => void;
}

export const ClipZoom: React.FC<ClipZoomProps> = ({
    zoomValue,
    zoomMax = 20,
    canZoomIn = true,
    canZoomOut = true,
    onChange }) => {

    const [currentZoomLevel, setCurrentZoomLevel] = useState<number>(zoomValue);

    const zoomInOnClick = () => {
        const newValue = currentZoomLevel + 1;
        setCurrentZoomLevel(newValue);
        onChange?.({ newValue: newValue });
    }

    const zoomOutOnClick = () => {
        const newValue = currentZoomLevel - 1;
        setCurrentZoomLevel(newValue);
        onChange?.({ newValue: newValue });
    }

    useEffect(() => {
        setCurrentZoomLevel(zoomValue);
    }, [zoomValue]);

    return (
        <div className="clip-zoom-container">
            <div className="clip-zoom-out">
                <GlyphButton ariaLabel="zoom-in"
                    className="component-button"
                    disabled={!canZoomOut}
                    IconComponent={<ZoomOut height={16} width={13.6655} viewBox="0 0 27.331 32" />}
                    onClick={zoomOutOnClick} />
            </div>
            <div className="clip-zoom-slider">
                <input
                    type="range"
                    min={0}
                    max={zoomMax}   // ZOOM_STEPS
                    value={currentZoomLevel}
                    onChange={(e) => {
                        const newValue = Number(e.target.value);
                        setCurrentZoomLevel(newValue);
                        onChange?.({ newValue });
                    }}
                />
            </div>
            <div className="clip-zoom-in">
                <GlyphButton ariaLabel="zoom-in"
                    className="component-button"
                    disabled={!canZoomIn}
                    IconComponent={<ZoomIn height={16} width={13.6655} viewBox="0 0 27.331 32" />}
                    onClick={zoomInOnClick} />
            </div>
        </div>
    );
};
